export const QUESTION_ANSWERED = 'QUESTION_ANSWERED';

function questionAnswered(questionnaireType, blockId, questionId, answer) {
  return {
    type: QUESTION_ANSWERED,
    questionnaireType,
    blockId,
    questionId,
    answer
  };
}

export function answerBlockQuestion(questionnaireType, blockId, questionId, answer) {
  return (dispatch) => {
    dispatch(questionAnswered(questionnaireType, blockId, questionId, answer));
  };
}
